import React, { useState, useEffect } from 'react';

const LineaDeAvance = (p) => {
    const avance = [null, undefined].includes(p.avance) || p.avance > 100 || p.avance < 0 ? 0 : p.avance;
    const bwWidth = p.bwWidth ?? 'bw-1200'
    const height = p.height ?? '1.5';

    const getColor = (value) => {
        if (value <= 35) return '#d60300'; // rojo encendido
        if (value <= 50) return '#ea8300'; // naranja intenso
        if (value < 80) return '#deda00'; // amarillo dorado
        if (value <= 100) return '#00b648 '; // verde
        return '#0095c4'; // azul
    };

    const color = getColor(avance);


    return (
        <div className={`${bwWidth} border round-xxl p-0 mt-2 bg-light`} style={{}}>
            <div className='row justify-content-start w-100 m-0 p-0'>
                <div className='round-xxl bw' style={{
                    width: `${Math.min(100, avance)}%`,
                    padding: `${height}px`,
                    backgroundColor: "#dddddd",
                    transition: "width 1s ease, background-color 1s ease",
                    backgroundColor: `${getColor(avance)}`
                }}></div>
            </div>
        </div>
    )
}

export default LineaDeAvance;